import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Education } from './education';

export interface EducationCollection {
  getEducation(): Observable<Education[]>;
  addEducation(education: Education): Promise<unknown>;
  editEducation(education: Education): Promise<void>;
  deleteEducation(education: Education): Promise<void>;
}

export const EDUCATION_COLLECTION = new InjectionToken<EducationCollection>(
  'EDUCATION_COLLECTION',
);
